import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { sectionsGroupsTabs } from './helpers/index';

const SectionsGroupsTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={sectionsGroupsTabs(contentTranslationLanguages)} />;
};

export default SectionsGroupsTabs;
